import { render, staticRenderFns } from "./DialogConfirmFileExtension.vue?vue&type=template&id=886d4782&scoped=true"
import script from "./DialogConfirmFileExtension.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogConfirmFileExtension.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DialogConfirmFileExtension.vue?vue&type=style&index=0&id=886d4782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886d4782",
  null
  
)

export default component.exports